import * as React from "react";
import { Change } from "../../../../global/interfaces/Change";
import columns from "./columns";
import { StyledDataGrid } from "./styledDataGrid";
import { GridColDef, GridToolbar, deDE } from "@mui/x-data-grid";

export default function ChangesDataTable(props: { changes: Change[] }) {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flex: 1,
        minHeight: 250,
      }}
    >
      <StyledDataGrid
        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        rows={props.changes || []}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
        slots={{ toolbar: GridToolbar }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
    </div>
  );
}
